module.exports = __webpack_public_path__ + "img/all-cover.81901cff.png";